import React, { useEffect, useState } from 'react';
import { useMap } from 'react-map-gl';
import "./TopButtons.css";
import { MAP_STYLES } from "../InitMap/MapConfig";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEarthAmericas } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../../../common/ToolTip/ToolTip';
import { useTranslation } from 'react-i18next';

export default function SattliteButton() {

    const { t } = useTranslation("nbhd");
    const [satOn, toggleSat] = useState(false);
    const map = useMap()

    const toggle = () => {
        toggleSat(!satOn);
    }

    useEffect(() => {
        if (!map.current){
            return;
        }
        if (satOn) {
            map.current.getMap().setStyle(MAP_STYLES["satellite"].uri);
        } else {
            map.current.getMap().setStyle(MAP_STYLES["streets"].uri);
        }
    }, [satOn, map])

    return (
        <button className={'mapboxgl-ctrl mapboxgl-ctrl-group sattlite-button' + (satOn ? " active" : "")} onClick={() => toggle()} aria-label="mapbox-sattelite-view-btn">
            <Tooltip content={t('nbhd.Map-Nav.sattlite')} direction={'left'}><FontAwesomeIcon icon={faEarthAmericas} /></Tooltip>
        </button>
    )

}
